import { useQuery } from '@tanstack/react-query'

import { trainingService } from '../services/trainingService'

interface UseGetLessonByIdProps {
  lessonId: string
  enabled?: boolean
}

export const useGetLessonById = ({
  lessonId,
  enabled,
}: UseGetLessonByIdProps) => {
  return useQuery({
    queryKey: ['lesson', lessonId],
    enabled,
    queryFn: () => trainingService.getLessonById(lessonId),
  })
}
